{
  "SET_NEW_PASSWORD": {
    "TITLE": "Set new password",
    "PASSWORD": {
      "LABEL": "Κωδικός",
      "PLACEHOLDER": "Κωδικός",
      "ERROR": "Ο κωδικός είναι πολύ σύντομος."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Confirm password",
      "PLACEHOLDER": "Επιβεβαίωση κωδικού",
      "ERROR": "Οι κωδικοί δεν ταιριάζουν."
    },
    "API": {
      "SUCCESS_MESSAGE": "Ο κωδικός άλλαξε με επιτυχία.",
      "ERROR_MESSAGE": "Αδυναμία σύνδεσης με τον Woot Server, Παρακαλώ προσπαθήστε αργότερα"
    },
    "CAPTCHA": {
      "ERROR": "Η επαλήθευση έληξε. Παρακαλώ λύστε ξανά captcha."
    },
    "SUBMIT": "Καταχώρηση"
  }
}
